import './SwitchWithTooltip.css';

import React from 'react';
import { Tooltip, CircularProgress, Switch } from '@mui/material';
import { generateClassName } from './helpers';

const SwitchWithTooltip = ({ checked, loading, onChange, tooltipTitle, className, tooltipPlacement, ...props }) => {
    return (
        <Tooltip title={tooltipTitle} arrow placement={tooltipPlacement}>
            <div className={generateClassName('switch-with-tooltip','',className)}>
                {loading ? (
                    <CircularProgress size={20} />
                ) : (
                    <Switch
                        checked={checked}
                        onChange={onChange}
                        color="primary"
                        inputProps={{ 'aria-label': 'toggle switch' }}
                        {...props}
                    />
                )}
            </div>
        </Tooltip>
    );
};

export default SwitchWithTooltip;
